module.exports = __webpack_public_path__ + "fonts/996dd89e-14cc-474b-ab23-4c08626c90af.91ebceaf.woff";